<template>
  <div class="mc-videohistory-list__history--wrapper">
    <div class="mc-videohistory-list__history--container">
      <div class="mc-videohistory-list__history--text">
        <p>{{ $t('videoHistory.video.listOfVideos') }}</p>
      </div>
      <multiselect
        v-model="camera"
        class="w-50"
        :options="options"
        label="label"
        :placeholder="$t('global.form.select') + ' ' + $t('trackVideo.camera')"
        @select="switchCamera"
      />
    </div>

    <div class="mc-videohistory-videos--container">
      <div class="mc-videohistory-list__item--container">
        <div
          v-if="$store.state.vehicle.isLoadingVehicleVideos"
          class="mc-videohistory-list__data--container"
        >
          <b-spinner label="Loading..." />
        </div>

        <div
          v-if="
            !$store.state.vehicle.isLoadingVehicleVideos &&
            vehicleVideoHistory &&
            vehicleVideoHistory.vehicleVideos &&
            vehicleVideoHistory.vehicleVideos.length === 0
          "
          class="mc-videohistory-list__data--container"
        >
          <div class="mc-videohistory-list__no-data--wrapper">
            <img src="@/assets/images/nodata.png" />
            <p class="mc-videohistory-list__no-data--title">
              {{ $t('videoHistory.histories.noData.info') }}
            </p>
            <p class="mc-videohistory-list__no-data--message">
              {{ $t('videoHistory.histories.noData.message') }}
            </p>
          </div>
        </div>

        <div
          v-if="
            !$store.state.vehicle.isLoadingVehicleVideos && vehicleVideoHistory.vehicleVideos.length
          "
          class="mc-videohistory-list__record"
        >
          <div v-for="(vehicle, index) in $store.state.vehicle.vehicleVideos" :key="index">
            <b-button
              v-b-toggle="`collapse-history-${index + 1}`"
              variant="info"
              :class="{
                'mc-videohistory-list__item--collapse': true,
                'mc-videohistory-list__item-collapse--visible': isCollapsed[index],
              }"
              @click="toggleCollapse(index)"
            >
              <span>{{ vehicle.dateTime }} {{ formatTimezone }}</span>
              <span>
                ({{ vehicle.videos.length }})
                <i v-if="isCollapsed[index]" class="mc-fa fa-lg icon-fill_chevron-up"></i>
                <i v-else class="mc-fa fa-lg icon-fill_chevron-down"> </i>
              </span>
            </b-button>
            <b-collapse
              :id="`collapse-history-${index + 1}`"
              v-model="isCollapsed[index]"
              class="mc-videohistory-list__item-history--collapse p-3"
              accordion="histories-accordion"
              role="tabpanel"
            >
              <table class="mc-videohistory-item__data--container">
                <tbody>
                  <tr
                    v-for="(video, indexVideo) in vehicle.videos"
                    :key="indexVideo"
                    :ref="`videoRow${index}-${indexVideo}`"
                    :class="{
                      'mc-videohistory-item__table-row--wrapper': true,
                      'mc-videohistory-item__highlighted':
                        $store.state.vehicle.startTime == video.startTime ||
                        $store.state.vehicle.downloadVideoPerItemStatus.includes(
                          `${index}:${indexVideo}`
                        ),
                    }"
                  >
                    <td width="90%" class="card-text history-video-time">
                      {{ video.time }}
                    </td>
                    <td>
                      <span
                        :id="`buttonDownlaod${index}${indexVideo}`"
                        class="mc-videohistory-list__download--button"
                      >
                        <b-spinner
                          v-if="
                            $store.state.vehicle.downloadVideoPerItemStatus.includes(
                              `${index}:${indexVideo}`
                            )
                          "
                          small
                          label="Loading..."
                        />

                        <i
                          v-else
                          id="download"
                          v-b-tooltip.hover.left="$t('videoHistory.downloadVideo')"
                          class="mc-fa icon-outline_save"
                          @click="downloadVideo(video, index, indexVideo)"
                        ></i>
                      </span>
                    </td>
                    <td
                      v-if="hasAccess(['stream_video_history:read'])"
                      class="card-text"
                      align="center"
                    >
                      <div
                        v-if="
                          videoStates.isLoading &&
                          (pickVideo.index !== index || pickVideo.indexVideo !== indexVideo)
                        "
                        class="mc-videohistory-list__button--loading"
                      >
                        <i class="mc-fa icon-fill_play-circle"></i>
                      </div>
                      <div v-else>
                        <template v-if="$store.state.vehicle.startTime == video.startTime">
                          <span
                            v-if="$store.state.vehicle.videoState === 'connecting'"
                            class="mc-videohistory-list__pause--button"
                          >
                            <b-spinner small label="Loading..." />
                          </span>
                          <span
                            v-else-if="$store.state.vehicle.videoState === 'ready'"
                            class="mc-videohistory-list__play--button"
                          >
                            <i class="mc-fa icon-fill_pause" @click="pauseStream()"></i>
                          </span>
                          <span
                            v-else-if="$store.state.vehicle.videoState === 'pause'"
                            class="mc-videohistory-list__play--button"
                          >
                            <i class="mc-fa icon-fill_play-circle" @click="continueStream()"></i>
                          </span>
                          <span
                            v-else-if="$store.state.vehicle.videoState === 'ended'"
                            class="mc-videohistory-list__play--button"
                          >
                            <i
                              class="mc-fa icon-fill_play-circle"
                              @click="playStream(video, index, indexVideo)"
                            ></i>
                          </span>
                        </template>
                        <span
                          v-else
                          :id="`buttonPlay${index}${indexVideo}`"
                          class="mc-videohistory-list__play--button"
                        >
                          <i
                            v-b-tooltip.hover.right="$t('videoHistory.playVideo')"
                            class="mc-fa icon-fill_play-circle"
                            @click="playStream(video, index, indexVideo)"
                          ></i>
                        </span>
                      </div>
                    </td>
                    <td v-else class="card-text"></td>
                  </tr>
                </tbody>
              </table>
            </b-collapse>
          </div>
        </div>

        <b-button
          v-b-modal.download-history
          class="w-100"
          size="sm"
          variant="outline-primary"
          @click="clickModalParameterDownload"
        >
          <i class="mc-fa icon-outline_download" />
          {{ $t('videoHistory.modalVideoDownload.title') }}
        </b-button>
        <HistoriesFilter />
      </div>
    </div>
  </div>
</template>

<script>
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'
import { mapGetters } from 'vuex'
import responsive from '@/mixin/responsive'
import Multiselect from 'vue-multiselect'
import HistoriesFilter from './Filter'
import { v4 as uuidv4 } from 'uuid'
import moment from 'moment'
moment.locale('id')

export default {
  name: 'HistoryList',
  components: {
    Multiselect,
    HistoriesFilter,
  },
  mixins: [Helper, responsive, MixPanel],
  data() {
    return {
      cameraButtonStatus: {
        cameraOut: true,
        cameraIn: false,
      },
      camera: null,
      options: [],
      isCollapsed: [],
      statusDeviceStream: '',
      uploadStatus: '',
      isReplaylist: false,
      param: null,
    }
  },
  computed: {
    ...mapGetters('vehicle', [
      'vehicleVideoHistory',
      'vehicleDetail',
      'vehicleId',
      'pickVideo',
      'vehiclePeriod',
      'videoStates',
      'streamChanged',
      'vehicleVideoUpload',
      'streamVehicleStatus',
      'vehicleCameraPosition',
    ]),
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
    ...mapGetters({
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    statusText() {
      return this.$store.state.vehicle.statusText
    },
    isVideoDemo() {
      const dataDemoVideoHistory = this.getFeatureFlagValue('vsms2_trackvision2_playback_demo_id')
      return Object.keys(dataDemoVideoHistory).includes(this.$route.params.vehicleId.toString())
    },
    formatTimezone() {
      if (this.$store.state.vehicle.deviceTimezone === 7) return 'WIB'
      if (this.$store.state.vehicle.deviceTimezone === 8) return 'WITA'
      if (this.$store.state.vehicle.deviceTimezone === 9) return 'WIT'
      return 'WIB'
    },
  },

  watch: {
    statusText(statusText) {
      this.options = []
      statusText.forEach((row, index) => {
        this.options.push({
          value: row,
          label: `${this.$t('trackVideo.camera')} ${index + 1}`,
        })
      })

      this.camera = this.options[0]
      const deviceName = this.$store.state?.vehicle?.vehicleDetail?.deviceName
      const payload = {
        camera: this.camera?.label,
        channel:
          deviceName === 'jc'
            ? `0${parseInt(this.camera?.value) + 1}`
            : this.addLeadingZero(this.camera?.value),
      }
      this.$store.commit('vehicle/setCamera', payload)
    },
    '$store.state.vehicle.videoState'(val) {
      if (val === 'noVideo' || val === 'error') {
        this.$store.commit('vehicle/setStartTime', '')
      }
    },
    pickVideo: function (newVal, oldVal) {
      if (oldVal) {
        this.isCollapsed[oldVal.index] = false
      }

      this.isCollapsed[newVal.index] = true
      // this.$nextTick(() => {
      //   this.scrollToActiveRow()
      // })
    },
  },

  mounted() {
    this.$store.commit('vehicle/resetDownloadVideoPerItemStatus')
  },
  methods: {
    async requestFileList() {
      if (!this.$store.state.vehicle.vehicleDetail?.imei) return
      await this.$store.dispatch('vehicle/requestUpdateFileList', {
        input: {
          imei: this.$store.state.vehicle.vehicleDetail.imei,
        },
      })
    },

    /**
     *
     * @param channel example : 01, 02, 03 etc
     */
    async requestVehihcleVideos(channel) {
      const filter = {
        vehicleId: this.vehicleId,
        startTime: this.formatDateToUtc(this.vehiclePeriod[0]),
        endTime: this.formatDateToUtc(this.vehiclePeriod[1]),
        channel: `CH${channel}`,
        fileListOnly: true,
      }

      this.$store.commit('vehicle/setLoadingVehicleVideos', true)
      let response
      response = await this.$store.dispatch('vehicle/requestVehicleVideosTv2', {
        ...filter,
        isFromCache: true,
      })
      if (!response.files.length) {
        if (this.$store.state.vehicle.vehicleDetail.deviceName === 'bsj') {
          await this.delay(5000)
        }
        if (this.$store.state.vehicle.vehicleDetail.deviceName === 'jc') {
          await this.delay(5000)
        }
        response = await this.$store.dispatch('vehicle/requestVehicleVideosTv2', {
          ...filter,
          isFromCache: false,
        })
      }
      this.$store.dispatch('vehicle/splitVehicleVideos', {
        videoFiles: response.files,
        lastUpdate: response.lastUpdate,
        filter: {
          startTime: this.formatDateToUtc(this.vehiclePeriod[0]),
          endTime: this.formatDateToUtc(this.vehiclePeriod[1]),
        },
      })
      await this.$store.commit('vehicle/setLoadingVehicleVideos', false)
    },

    /**
     *
     * @param channel example : 01, 02, 03 etc
     */
    async setVideoDemo(channel) {
      this.$store.commit('vehicle/setLoadingVehicleVideos', true)

      await this.delay(500)
      this.$store.dispatch('vehicle/setVehicleVideosDemo', {
        vehicleId: this.$route.params.vehicleId.toString(),
        channel,
      })

      this.$store.commit('vehicle/setLoadingVehicleVideos', false)
    },

    async switchCamera(e) {
      const channel =
        this.$store.state.vehicle.vehicleDetail.deviceName === 'jc'
          ? this.addLeadingZero(parseInt(e.value) + 1)
          : this.addLeadingZero(parseInt(e.value))

      const payload = {
        camera: e.label,
        channel: channel,
      }

      this.$store.commit('vehicle/setCamera', payload)
      this.$store.commit('vehicle/setVideoStatusDetail', 'noVideo')
      this.$store.commit('vehicle/clearVehicleVideos')
      this.$store.commit('vehicle/clearVideoStates')
      this.$store.commit('vehicle/clearPickVideo')
      this.$store.commit('vehicle/setCamera', payload)

      const deviceName = this.$store.state.vehicle.vehicleDetail.deviceName
      if (deviceName === 'bsj') {
        this.$store.commit('vehicle/setLoadingVehicleVideos', true)
        await this.requestFileList()
        await this.delay(1000)
      }

      if (this.isVideoDemo) {
        this.setVideoDemo(channel)
      } else {
        this.requestVehihcleVideos(channel)
      }
    },

    toggleCollapse(index) {
      this.isCollapsed[index] = !this.isCollapsed[index]
    },

    scrollToActiveRow() {
      if (
        this.pickVideo &&
        this.$refs[`videoRow${this.pickVideo.index}-${this.pickVideo.indexVideo}`] &&
        this.$refs[`videoRow${this.pickVideo.index}-${this.pickVideo.indexVideo}`].length > 0
      ) {
        const row = this.$refs[`videoRow${this.pickVideo.index}-${this.pickVideo.indexVideo}`][0]
        row.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        })
      }
    },

    notifStream() {
      switch (this.streamVehicleStatus.toLowerCase()) {
        case 'failed':
          this.$mcToast.error(this.$t('global.alert.text.sdCardStreamFailed'))
          break
        default:
          break
      }
    },

    async playStream(video, index, indexVideo) {
      this.$store.commit('vehicle/setSource', '')
      this.$store.commit('vehicle/setVideoStatusDetail', 'connecting')
      this.$store.commit('vehicle/setStartTime', video.startTime)
      this.$store.commit('vehicle/setIsVideoHasBeenPaused', false)

      this.track('Play Streaming Video History')

      if (this.isVideoDemo) {
        const url = await this.$store.dispatch('vehicle/getSignedUrlVideoDemo', video.mediaFilename)

        const source = {
          id: this.vehicleDetail.imei,
          startTime: video.startTime,
          src: url,
        }
        this.$store.commit('vehicle/setSource', source)
        await this.delay(500)
        this.$store.commit('vehicle/setIndexVideoActive', [index, indexVideo])
        this.$store.commit('vehicle/setVideoStatusDetail', 'ready')
        return
      }

      try {
        const deviceName = this.$store.state.vehicle.vehicleDetail.deviceName
        const uid = uuidv4()
        const input =
          deviceName === 'jc'
            ? {
                jcInput: {
                  filename: video.mediaFilename,
                },
              }
            : {
                bsjInput: {
                  channel: `CH${this.addLeadingZero(video.channel)}`,
                  endTime: this.formatDateToUtc(video.endTime),
                  startTime: this.formatDateToUtc(video.startTime),
                },
              }

        await this.delay(2000)

        const response = await this.$store.dispatch('vehicle/requestStreamFromDevice', {
          status: true,
          imei: this.vehicleDetail.imei,
          statsDataV2: {
            tvType: 'TV2',
            idRequest: uid,
          },
          ...input,
        })

        if (response.setDeviceStream.message !== 'Sent') {
          this.$store.commit('vehicle/setVideoStatusDetail', 'noVideo')
          const responseMessage = response.setDeviceStream.message
          if (responseMessage === 'There is a playback or streaming going on') {
            return this.$mcToast.error(this.$t('videoHistory.video.playbackOrStreamingGoinOn'))
          }

          return this.$mcToast.error(this.$t('videoHistory.video.streamError'))
        }

        this.$store.commit('vehicle/setIndexVideoActive', [index, indexVideo])
        this.$store.commit('vehicle/setPlaybackUidActive', uid)

        const getRtmpUrl = (type, imei, channel) => {
          if (type === 'jc')
            return `${process.env.VUE_APP_RTMP_URL.replace('{numFlag}', 1)}/live/${imei}.flv`
          if (type === 'bsj')
            return `${process.env.VUE_APP_RTMP_URL.replace(
              '{numFlag}',
              1
            )}/live/stream/${imei}-${channel}.flv`
        }

        const source = {
          id: this.vehicleDetail.imei,
          startTime: video.startTime,
          src:
            deviceName === 'jc'
              ? getRtmpUrl('jc', this.vehicleDetail.imei)
              : getRtmpUrl('bsj', this.vehicleDetail.imei, video.channel),
        }
        this.$store.commit('vehicle/setSource', source)
        return response.setDeviceStream.message
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err)
        return this.$mcToast.error(this.$t('videoHistory.video.streamError'))
      }
    },

    pauseStream() {
      this.track('Stop Streaming Video History')
      if (this.$store.state.vehicle.videoState === 'ready') {
        this.$store.commit('vehicle/setVideoStatusDetail', 'pause')
        this.$store.commit('vehicle/setIsVideoHasBeenPaused', true)
      }
    },

    continueStream() {
      if (this.$store.state.vehicle.videoState === 'pause') {
        this.$store.commit('vehicle/setVideoStatusDetail', 'ready')
      }
    },

    async downloadVideo(video, index, indexVideo) {
      this.$store.commit('vehicle/addDownloadVideoPerItemStatus', [index, indexVideo])
      if (this.isVideoDemo) {
        this.$store.commit('vehicle/updateLoadingDownloadVideoHistoriesWidget', true)
        await this.delay(1000)
        this.$mcToast.success(this.$t('videoHistory.processingDownloadVideo'))
        const url = await this.$store.dispatch('vehicle/getSignedUrlVideoDemo', video.mediaFilename)

        const videoData = {
          channel: video.channel,
          downloadId: this.$store.state.vehicle.downloadVideoHistoriesWidgetData.length,
          downloadOn: this.now(),
          endTime: this.momentAdd(video.startTime, 1, 'minute').format('YYYY-MM-DDTHH:mm:ss'),
          mediaFilename: video.mediaFilename,
          startTime: video.startTime,
          url: url,
          users: {
            fullname: this.$store.state.identity.whoami.name,
          },
          vehicle: {
            hullNo: null,
            id: this.$route.params.vehicleId,
            licensePlate: this.$store.state.vehicle.vehicleDetail.licensePlate,
            vehicleType: {
              category: this.$store.state.vehicle.vehicleDetail.vehicleCategory,
              type: this.$store.state.vehicle.vehicleDetail.vehicleType,
            },
          },
        }
        this.$store.commit('vehicle/updateDownloadVideoHistoriesWidgetData', [
          ...this.$store.state.vehicle.downloadVideoHistoriesWidgetData,
          { ...videoData, status: 'I' },
        ])
        document.body.classList.add('mc-widget-download')
        await this.delay(5000)
        this.$store.commit(
          'vehicle/updateDownloadVideoHistoriesWidgetData',
          this.$store.state.vehicle.downloadVideoHistoriesWidgetData.filter(
            (data) => data.startTime !== video.startTime
          )
        )
        this.$store.commit('vehicle/updateDownloadVideoHistoriesSuccessData', [
          ...this.$store.state.vehicle.downloadVideoHistoriesSuccessData,
          {
            ...videoData,
            status: 'S',
          },
        ])
        this.$store.commit('vehicle/removeDownloadVideoPerItemStatus', [index, indexVideo])
        return
      }
      this.track('Click Video History Download', {
        license_plate: this.vehicleDetail.licensePlate,
        filename: `${video.mediaFilename}`,
      })
      const deviceName = this.$store.state?.vehicle?.vehicleDetail?.deviceName
      const isJc = deviceName === 'jc'
      const isBsj = deviceName === 'bsj'
      const variables = {
        input: {
          imei: this.$store.state?.vehicle?.vehicleDetail.imei,
        },
      }

      if (isJc) {
        variables.input['jcInput'] = {
          cameraPosition: parseInt(this.camera.value) + 1,
          filename: [video.mediaFilename],
        }
      } else if (isBsj) {
        variables.input['bsjInput'] = {
          channel: 'CH0' + this.camera.value,
          startTime: this.formatDateToUtc(video.startTime),
          endTime: this.formatDateToUtc(video.endTime),
        }
      }

      this.$store.commit('vehicle/updateLoadingDownloadVideoHistoriesWidget', true)
      this.$store.dispatch('vehicle/requestSetUploadMedia', variables).then((errorResponse) => {
        if (errorResponse) {
          this.$mcToast.error(errorResponse)
          this.$store.commit('vehicle/updateLoadingDownloadVideoHistoriesWidget', false)
        } else {
          const _variables = variables
          if (isJc) {
            _variables.input.jcInput['startTime'] = this.formatDateToUtc(video.startTime)
            _variables.input.jcInput['endTime'] = this.formatDateToUtc(
              moment(video.startTime).add(1, 'minutes').format('YYYY-MM-DDTHH:mm:ss')
            )
          }
          this.$store.commit('vehicle/updateDownloadVideoHistoriesLastDownload', {
            ..._variables,
            vehicleId: this.$store.state.vehicle.vehicleId,
          })
          setTimeout(() => {
            this.donwloadProg()
          }, 3000)
        }
      })
    },

    donwloadProg() {
      const variables = {
        filter: {
          allUsers: false,
          startDate: this.today()[0],
          endDate: this.today()[1],
          orderBy: JSON.stringify({ downloadOn: 'desc' }),
        },
      }
      this.$store.dispatch('vehicle/requestDownloadVideoHistories', variables).then((data) => {
        if (data) {
          this.$store.commit('vehicle/updateDownloadVideoHistoriesFirstData', data)
          this.$store.commit('vehicle/updateDownloadVideoHistoriesWidgetData', data)
          this.$store.commit(
            'vehicle/updateDownloadVideoHistoriesInProgressFirstData',
            data.filter((video) => video.status === 'I')
          )
          this.$mcToast.success(this.$t('videoHistory.processingDownloadVideo'))
          document.body.classList.add('mc-widget-download')
        }
      })
    },

    clickModalParameterDownload() {
      this.track('Open Parameter Download Video History')
    },
  },
}
</script>
